import React, { Component } from "react";
import "./ScoreReport.scss";
import homeIcon from "../../assets/images/home_icon.png";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import { connect } from "react-redux";
import star_0 from "../../assets/images/score_report_0_star_icon.png";
import star_1 from "../../assets/images/score_report_1_star_icon.png";
import star_2 from "../../assets/images/score_report_2_star_icon.png";
import star_3 from "../../assets/images/score_report_3_star_icon.png";
import incorrectIcon from "../../assets/images/cross_icon.png";
import moment from "moment";
import { replace, toNumber } from "lodash";
import LoaderComponent from "../LoaderComponent";
import { getScoreFeedback } from "../../actions";

const difficultyLevels = {
  E: "Easy",
  M: "Medium",
  H: "Hard",
  A: "All",
};

class ScoreReport extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      feedbackData: "",
      feedbackType: "",
    };
  }
  componentDidMount() {
    if (!this.props.scoreReport) {
      this.props.history.push("/");
    } else {
      const { cookies, scoreReport } = this.props;
      let currentDateTime = moment();
      let appSettings = cookies.get("app_settings");
      if (
        this.props.history.location.state &&
        this.props.history.location.state.isTest === "1"
      ) {
        let data = {
          date:
            currentDateTime.format("ddd") +
            " " +
            currentDateTime.format("MM/DD"),
          time: currentDateTime.format("LT"),
          score: scoreReport.scorePercentage + "%",
        };
        if (appSettings.best_test_score.score) {
          if (
            toNumber(replace(data.score, "%", "")) >=
            toNumber(replace(appSettings.best_test_score.score, "%", ""))
          ) {
            appSettings.best_test_score = data;
          }
        } else {
          appSettings.best_test_score = data;
        }
        appSettings.test_score = data;
        cookies.set("app_settings", appSettings);
      } else {
        appSettings.last_quiz.diff =
          difficultyLevels[scoreReport.quizDifficulty];
        appSettings.last_quiz.date =
          currentDateTime.format("ddd") + " " + currentDateTime.format("MM/DD");
        appSettings.last_quiz.time = currentDateTime.format("LT");
        appSettings.last_quiz.score = scoreReport.scorePercentage + "%";
        cookies.set("app_settings", appSettings);
      }

      if (
        scoreReport.scorePercentage === 0 ||
        scoreReport.scorePercentage === 100
      ) {
        let scoreText = scoreReport.scorePercentage === 0 ? "zero" : "perfect";
        this.props
          .getScoreFeedback("?score=" + scoreText)
          .then((res) => {
            let { OutputType, FData } = res.data[0];
            this.setState(
              {
                isLoading: false,
                feedbackType: OutputType,
                feedbackData: FData,
              },
              () => {
                this.resetHeaderPosition();
                $(".score-data-container").animate({ scrollTop: 0 }, "fast");
              }
            );
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.setState(
          {
            isLoading: false,
          },
          () => {
            this.resetHeaderPosition();
            $(".score-data-container").animate({ scrollTop: 0 }, "fast");
          }
        );
      }
    }

    window.addEventListener("resize", this.resetHeaderPosition);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resetHeaderPosition);
  }

  resetHeaderPosition = () => {
    if (document.getElementById("scorepage_header") !== null) {
      let headerHeight = document.getElementById("scorepage_header")
        .offsetHeight;
      $(".score-data-container").css("padding-top", headerHeight + "px");
      if ($(".feedback-container")) {
        $(".feedback-container").css("padding-top", headerHeight + 20 + "px");
      }
    }
  };

  getStarsImage = (percentage) => {
    if (percentage >= 50 && percentage < 75) {
      return star_1;
    } else if (percentage >= 75 && percentage < 90) {
      return star_2;
    } else if (percentage >= 90 && percentage <= 100) {
      return star_3;
    } else {
      return star_0;
    }
  };

  render() {
    const { scoreReport, questionSetDetails } = this.props;
    const { isLoading, feedbackData, feedbackType } = this.state;
    this.resetHeaderPosition();
    return (
      <div className="score-report-page-container">
        {isLoading || !scoreReport ? (
          <LoaderComponent loading={isLoading} />
        ) : (
          <React.Fragment>
            <div className="question-header-container" id="scorepage_header">
              <div className="container-area">
                <div className="header-content">
                  <NavLink className="home-icon-container" to={"/"}>
                    <img src={homeIcon} alt="home" />
                  </NavLink>
                  <div className="page-title-container">Score Report</div>
                  <div className="refresh-icon-container"></div>
                </div>
                <div className="score-numbers-container">
                  <div className="score-data">
                    <div className="score-star-container">
                      <img
                        src={this.getStarsImage(scoreReport.scorePercentage)}
                        alt="star"
                      />
                      <div className="score-percentage">
                        {scoreReport.scorePercentage + "%"}
                      </div>
                    </div>
                    <div className="report-details-container">
                      <div className="correct-answers-count">
                        {scoreReport.totalCorrect} of{" "}
                        {scoreReport.totalQuestions} Correct
                      </div>
                      <div className="points-count">
                        {Math.round(scoreReport.correctPoints)} of{" "}
                        {scoreReport.totalPoints} Points
                      </div>
                      <div className="difficulty-level">
                        Difficulty{" "}
                        {this.props.history.location.state &&
                        this.props.history.location.state.isTest === "1"
                          ? "Full Test"
                          : difficultyLevels[scoreReport.quizDifficulty]}
                      </div>
                      <div className="quiz-test-time">
                        {scoreReport.quizTestTime}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {scoreReport.scorePercentage !== 0 &&
            scoreReport.scorePercentage !== 100 &&
            scoreReport.totalCorrect !== scoreReport.totalQuestions ? (
              <div className="score-data-container">
                <div className="container-title">Questions Marked Wrong:</div>

                <div className="data-list">
                  {scoreReport.incorrectQuestions.map((item, itemIndex) => {
                    return item.QTypeShort === "MAT" &&
                      item.correctAnswersCount === item.expectedAnswersCount ? (
                      ""
                    ) : item.QTypeShort === "PIO" && item.isCorrect === 1 ? (
                      ""
                    ) : (
                      <div className="single-block" key={"q_" + itemIndex}>
                        <div className="question-title">
                          <span>{item.number + ") "}</span>
                          {item.question}
                        </div>
                        {item.questionGraphic && (
                          <div className="question-graphic">
                            <img
                              src={
                                questionSetDetails.QSResourcePath +
                                item.questionGraphic
                              }
                              alt="graphic"
                            />
                          </div>
                        )}
                        <div className="question-answers-list">
                          {item.QTypeShort === "MAT" && (
                            <React.Fragment>
                              <div className="single-answer">
                                <div className="incorrect-icon">
                                  <img src={incorrectIcon} alt="incorrect" />
                                </div>
                                <div className="answer-text">
                                  {item.answerSummary}
                                </div>
                              </div>

                              {item.answers.map((ans, index) => {
                                return (
                                  <div
                                    className="single-answer"
                                    key={"sub_ans_" + itemIndex + "_" + index}
                                  >
                                    <div className="answer-text">
                                      {ans[2] === "P" ? (
                                        ans[0]
                                      ) : (
                                        <span>
                                          {ans[0]} &ne; {ans[1]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </React.Fragment>
                          )}
                          {(item.QTypeShort === "MTR" ||
                            item.QTypeShort === "MCH") &&
                            item.answers.map((ans, ansIndex) => {
                              return (
                                <div
                                  className="single-answer"
                                  key={"q_" + itemIndex + "_a_" + ansIndex}
                                >
                                  {item.QTypeShort !== "MTR" && (
                                    <div className="incorrect-icon">
                                      <img
                                        src={incorrectIcon}
                                        alt="incorrect"
                                      />
                                    </div>
                                  )}
                                  <div className="answer-text">{ans}</div>
                                </div>
                              );
                            })}
                          {item.QTypeShort === "PIO" && (
                            <React.Fragment>
                              <div className="single-answer">
                                <div className="incorrect-icon">
                                  <img src={incorrectIcon} alt="incorrect" />
                                </div>
                                <div className="answer-text">
                                  Incorrect Order
                                </div>
                              </div>
                              {item.answers.map((ans, ansIndex) => {
                                return (
                                  <div
                                    className="single-answer"
                                    style={{ paddingTop: "0px" }}
                                    key={"q_" + itemIndex + "_a_" + ansIndex}
                                  >
                                    <div className="incorrect-icon"></div>
                                    <div className="answer-text">
                                      {ans.answerValue}
                                    </div>
                                  </div>
                                );
                              })}
                            </React.Fragment>
                          )}
                          {item.QTypeShort === "MIX" &&
                            item.answers.map((ans, ansIndex) => {
                              return (
                                <div
                                  className="single-answer"
                                  key={"q_" + itemIndex + "_a_" + ansIndex}
                                >
                                  <div className="incorrect-icon">
                                    {ansIndex === 0 && (
                                      <img
                                        src={incorrectIcon}
                                        alt="incorrect"
                                      />
                                    )}
                                  </div>
                                  <div className="answer-text">
                                    {ans.join("")}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="feedback-container">
                {feedbackType === "TEXT" && (
                  <div className="feedback-text">{feedbackData}</div>
                )}
                {feedbackType === "URL" && (
                  <div className="feedback-image">
                    <img
                      src={questionSetDetails.QSResourcePath + feedbackData}
                      alt="feedback-data"
                    />
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    scoreReport: state.scoreReport,
    questionSetDetails: state.questionSetDetails,
  };
};

export default connect(mapStateToProps, { getScoreFeedback })(ScoreReport);
